import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { Layout } from "../components/layout";
import SEO from "../components/seo";
import { MarkdownBlock } from "../components/markdown-block";
import { MDXProvider } from "@mdx-js/react";
import { CategoryEntries } from "../components/category-entries";
import { ImportMarkdown } from "../components/import-markdown";
import { WishWidget, ShareTripWidget, TravelPlanWidget, WishCounterWidget } from "../wish-to-go-plugin/wtg-widgets";
import { StartWishToGo } from "../wish-to-go-plugin/start-wish-to-go";
import { CustomCategoryEntries } from "../custom-components/custom-category-entries";
import { Columns } from "../components/columns";
import { PopupForm } from "../custom-components/convertkit-forms";

var Page = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Page, _React$Component);

  function Page() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Page.prototype;

  _proto.render = function render() {
    var _mdx$frontmatter$feat, _featuredImageFile;

    var _this$props$data = this.props.data,
        mdx = _this$props$data.mdx,
        allFile = _this$props$data.allFile;

    var featuredImageFile = function featuredImageFile() {
      return allFile.nodes.find(function (file) {
        return file.publicURL.includes(mdx.fields.featuredImage);
      });
    };

    var featuredImage = ((_mdx$frontmatter$feat = mdx.frontmatter.featuredImage) === null || _mdx$frontmatter$feat === void 0 ? void 0 : _mdx$frontmatter$feat.publicURL) || ((_featuredImageFile = featuredImageFile()) === null || _featuredImageFile === void 0 ? void 0 : _featuredImageFile.publicURL);
    return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(SEO, {
      title: mdx.frontmatter.title,
      description: mdx.frontmatter.description || mdx.excerpt,
      featuredImage: featuredImage
    }), /*#__PURE__*/React.createElement(MDXProvider, {
      components: {
        CategoryEntries: CategoryEntries,
        ImportMarkdown: ImportMarkdown,
        Columns: Columns,
        WishWidget: WishWidget,
        TravelPlanWidget: TravelPlanWidget,
        WishCounterWidget: WishCounterWidget,
        ShareTripWidget: ShareTripWidget,
        StartWishToGo: StartWishToGo,
        CustomCategoryEntries: CustomCategoryEntries,
        PopupForm: PopupForm
      }
    }, /*#__PURE__*/React.createElement(MarkdownBlock, {
      className: mdx.frontmatter.className,
      frontmatter: mdx.frontmatter // Use from MDX file as <p>{props.frontmatter}</p>
      ,
      featuredImage: featuredImage
    }, mdx.body)));
  };

  return Page;
}(React.Component);

export default Page;
export var query = "295331224"; // do not remove the following comments. It is to avoid css purgin see: https://www.gatsbyjs.org/packages/gatsby-plugin-purgecss/#2-use-a-javascript-comment
// h3
// h4
// h5
// blockquote
// pre
// code
// hr
// svg
// token
// tag
// number 
// language-text
// page error-page
// index index-header readers-benefit card blue-border purple-border green-border book-demo blazing-fast
// blog-page
// blog-entry-card
// blog-main
// plans plans-grid plan-entries plans-faqs plan-card backpacker explorer globetrotter
// subscription subscribe social-sign-up
// share-trip-widget wish-counter-widget trip-planner login-provider-buttons view-panel controller-container